export * from './simple/simpleNoDataRenderer.component';
export * from './simple/simpleNoDataRenderer.interface';
